import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProgressBar from './component/progressBar';
import Openimage from '../../pages/mystery-box/images/open.png';
import Bg from '../../pages/money-fiesta/images/links3/background.jpg';
import Progress from '../../pages/money-fiesta/images/links3/cashback.png';
import BgBox from '../../pages/money-fiesta/images/links3/box.png';
import EarningButton from '../../pages/money-fiesta/images/links3/button.png';
import KeepShop from '../../pages/money-fiesta/images/links3/keep shop.png';
import Rich from '../../pages/money-fiesta/images/links2/rech.png';
import Clove from '../../pages/money-fiesta/images/links2/strech.png';
import Booking from '../../pages/money-fiesta/images/links2/booking.png';
import Flash from '../../pages/money-fiesta/images/links2/flash.png';
import Card from '../../pages/money-fiesta/images/links2/card.png';
import Faq from '../../pages/money-fiesta/images/links/faqs.png';
import ReactHtmlParser from 'html-react-parser';
import { useNavigate } from 'react-router-dom';


const faqs = [
  {
    question: "What is the Free Money Fiesta?",
    answer: "The Free Money Fiesta is a limited time offer where users can set a personalized cashback target and earn an additional bonus cashback (Free Money) if they achieve their goal within campaign duration."
  },
  {
    question: "How do I participate in the campaign?",
    answer: "Simply select your cashback goal from the available options and start shopping via the CashKaro app or website."
  },
  {
    question: "Do I need to register separately?",
    answer: "No, there is no separate registration required. Just choose your goal and start shopping!"
  },
  {
    question: "What happens if I achieve my cashback goal?",
    answer: "If you meet your selected target within the campaign duration, you will receive a bonus cashback on the total amount earned. This bonus cashback will be credited to your CashKaro account after the campaign ends."
  },
  {
    question: "Can I change my cashback goal after selecting one?",
    answer: "No, once you select a cashback goal, it cannot be changed for that campaign period."
  },
  {
    question: "Where can I shop to earn cashback for this campaign?",
    answer: "You can shop from any of your favourite brands listed on CashKaro, including: Flipkart, Amazon, Myntra, Ajio & more, Flash deals & exclusive offers, Credit card offers (earn up to ₹2200 cashback!), Biggest sales events "
  },
  {
    question: "How do I track my progress?",
    answer: "You can track your cashback progress on the cashback goal page, where a progress bar will be updated daily."
  },
  {
    question: "When will my bonus cashback be credited?",
    answer: "Your bonus cashback  will be credited to your CashKaro account after the campaign period ends and once all transactions are validated. Confirmed Cashback/Rewards amount will be considered for the bonus cashback (Free Money)."
  },
  {
    question: "What happens if my order gets cancelled or refunded?",
    answer: "If any of your transactions are cancelled or refunded, they will not count toward your cashback goal. Your progress bar will be adjusted accordingly."
  },
  {
    question: "Can I participate again in the next Cashback Goals campaign?",
    answer: "Yes! If we run another Cashback Goals campaign, you will get a new personalized target and can participate again.",
  },
  {
    question: "What happens if I don’t meet my cashback goal?",
    answer: "There’s no penalty! You will still receive the cashback you earned during the campaign, but you won’t be eligible for the bonus cashback.",
  },
  {
    question: "Are there any exclusions or limitations?",
    answer: "Yes, here are some key limitations: Transactions must be tracked and approved to count toward your goal. Fraudulent transactions or multiple accounts created to misuse the offer will not be considered. Cashbacks from canceled/refunded orders/referral bonus and any other bonus won’t count toward your target. ",
  },
  {
    question: "What if I have more questions?",
    answer: "For any additional queries, please visit the CashKaro Help Center or contact our customer support via the app or website.",
  }
];
const Terms = [
  {
    question: "What is CashKaro Cashback Goal?",
    answer: "CashKaro Cashback Goal is a limited-time campaign that allow users to set a personalized cashback target and earn extra bonus cashback upon achieving it within the campaign duration."
  },
  {
    question: "What is my target and what do I get after completing it? ",
    answer: "You can select your cashback goal target that you want to achieve between the campaign’s timeline. If you achieve your goal, you will receive bonus cashback in addition to your earned cashback"
  },
  {
    question: "Who can participate? ",
    answer: "Users who can see and get communication for the campaign are eligible."
  },
  {
    question: "Campaign Duration",
    answer: "8th Feb till 28th Feb "
  },
  {
    question: "How do I get the points?",
    answer: `<ul>
    <li>Shop from your favourite brands</li>
    <li>Shop from Flash Deals</li>
    <li>Apply credit cards and get up to ₹2200 cashback </li>
    <li>Shop from the biggest sales </li>
    <li>Shop from anywhere on the CashKaro app or website from retailers which offers cashback on the purchase.</li>
  </ul>`},
  {
    question: "Rewards or Benefits",
    answer: "Upon achieving your cashback milestone, you will receive an additional bonus cashback. The bonus cashback (Free Money), will be credited within 48 hours of you achieving your cashback goal. Please note that referral and any other special bonuses, Amazon recharge will be excluded from the tally of your cashback goal. End the end of the campaign, only confirmed cashback/rewards would be considered towards goal achievement.  The bonus cashback (Free Money) will be confirmed by 15th April."
  },
  {
    question: "Do I have to register for the contest?",
    answer: "No separate registration is required. Simply participate by selecting your cashback goal. "
  },
  {
    question: "Exclusions and Limitations",
    answer: `<ul>
    <li>Transactions that are cancelled, refunded, or deemed fraudulent will not be counted toward your cashback goal.</li>
    <li>The campaign is only valid on eligible purchases made through the CashKaro platform.</li>
    <li>Once users selected its cashback goal, it won’t be reselected or cancelled. </li>
  </ul>`},
  {
    question: "Adjustments and Termination",
    answer: "CashKaro reserves the right to modify or terminate the campaign at any time without prior notice. In case of discrepancies, including transaction cancellations or fraudulent activities, CashKaro reserves the right to adjust scores and rankings. No upward adjustments in rankings will occur due to another participant’s score adjustment; rankings may only decrease."
  },
  {
    question: "When is the progress bar updated? ",
    answer: "The progress bar will be updated daily, reflecting tracked transactions from the previous day. Cashback with the extra bonus will be determined based on the total transactions accumulated during the campaign period. "
  },
  {
    question: "Declaration by User ",
    answer: "These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of Gurugram, Haryana. By participating in the CashKaro Cashback Goal campaign, you acknowledge that you have read, understood, and agreed to these Terms and Conditions. "
  },
];
const style = {
  border: '1px solid transparent',
  marginLeft: '1rem',
  marginRight: '1rem',
  borderImageSource: 'linear-gradient(140.1deg, #525252 -8.09%, #0E0E0E 35.68%)',
  borderImageSlice: 1, // Ensures the gradient is applied to the border
  margin: '0 auto', // Centers the Box horizontally
  background: 'radial-gradient(97.73% 123.25% at 0% 0%, #1F1F1F 0%, #0D0D0D 69.18%)',
  borderRadius: '24px',
  WebkitMaskImage: "linear-gradient(white, white)"
};
const stylee = {
  margin: '0 auto', // Centers the Box horizontally
  background: "#0D0D0D"
}






const options = [
  {
    id: 1,
    title: "Free Money",
    prize: "100",
    description: "Cashback Goal",
    cashback: "2000",
  },
  {
    id: 2,
    title: "Free Money",
    prize: "150",
    description: "Cashback Goal",
    cashback: "2500",
  },
  {
    id: 3,
    title: "Free Money",
    prize: "200",
    description: "Cashback Goal",
    cashback: "3000",
  },
];
export default function MysteryBox() {
  const [selected, setSelected] = useState(null);

  const handleSelect = (id) => {
    setSelected(id);
  };
  const [alertOpen, setAlertOpen] = useState(false);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(0);
  const [Reveal, setReveal] = useState(false);
  const [registered, setRegistered] = useState(false)
  const [showGrid, setShowGrid] = useState(false);
  // const mbOpen = localStorage.getItem('mb_open')
  const navigate = useNavigate();
  const user = localStorage.getItem('fiesta_ck_id_jan')
  const [goal, setGoal] = useState(0)
  const [freeMoney, setFreeMoney] = useState(0)
  const [currentCashback, setCurrentCashback] = useState(0)

  const getUserData = async () => {
    if (!user) {
      navigate('/money-fiesta/index')
    }
    try {
      let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_fmf?ck_id=${user}`)
      response = await response.json()
      // console.log(response)
      setGoal(response?.user_data?.selected_cashback_goal)
      setFreeMoney(response?.user_data?.selected_free_money)
      setCurrentCashback(response?.user_data?.current_cashback)
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    getUserData()
  }, [])


  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}
        sx={{
          backgroundImage: `url(${Bg})`, backgroundSize: 'cover',
        }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <img src={Progress} alt='Progress' style={{ width: '60%' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <img src={BgBox} alt='BgBox' style={{ width: '100%', minHeight: '130px' }} />
        </div>


        {/* <div style={{ marginTop: '-6%' }}>
          <img src={SHadow} alt='SHadow' style={{ width: '100%' }} />
        </div> */}
        <Grid sx={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: "center", marginTop: '-26%', paddingLeft: '1rem', paddingRight: '1rem' }}>
          <div style={{ marginTop: '-4%', width: "40%" }}>
            <div>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
              <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />

              <text font-size="3px" font-family="Metropolis" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="#ffffff8c">
                <textPath href="#MyPath" startOffset="1">
                  Your Cashback Goal
                </textPath>
              </text>
            </svg> */}
              <Typography sx={{ fontSize: "10px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>Your Cashback Goal</Typography>
            </div>

            <div style={{}}>
              <Typography sx={{ fontSize: "24px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>  ₹{goal}</Typography>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
              <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />
              <text font-size="8px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="#ffffff8c">
                <textPath href="#MyPath" startOffset="1">
                  ₹{goal}
                </textPath>
              </text>
            </svg> */}
            </div>
          </div>
          <div style={{ marginTop: '-4%', width: "40%" }}>
            <div>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
              <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />

              <text font-size="3px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="#ffffff8c">
                <textPath href="#MyPath" startOffset="1">
                  Free Money
                </textPath>
              </text>
            </svg> */}
              <Typography sx={{ fontSize: "10px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>Free Money</Typography>

            </div>

            <div style={{}}>
              <Typography sx={{ fontSize: "24px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>  ₹{freeMoney}</Typography>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
              <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />
              <text font-size="8px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="#ffffff8c">
                <textPath href="#MyPath" startOffset="1">
                  ₹{freeMoney}
                </textPath>
              </text>
            </svg> */}
            </div>
          </div>
          <div style={{ marginTop: '-4%', width: "40%" }}>
            <div>
            <Typography sx={{ fontSize: "10px", fontWeight: "bold", textAlign: "center", color: "#fff" }}> Goal + Free Money</Typography>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
                <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />

                <text font-size="3px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="white">
                  <textPath href="#MyPath" startOffset="1">
                    Goal + Free Money
                  </textPath>
                </text>
              </svg> */}

            </div>

            <div style={{  }}>
            <Typography sx={{ fontSize: "24px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>  ₹{goal + freeMoney}</Typography>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
                <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />
                <text font-size="8px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="white">
                  <textPath href="#MyPath" startOffset="1">
                    ₹{goal + freeMoney}
                  </textPath>
                </text>
              </svg> */}
            </div>
          </div>
        </Grid>
        <div style={{ paddingLeft: '4rem', paddingRight: '4rem', marginTop: '4rem' }}>
          <Typography sx={{ color: '#fff', fontSize: '0.75rem', textAlign: 'center', fontFamily: 'Metropolis' }}>It might take up to 48 hours to add free money to your <span style={{ color: '#fce100' }}>My Earning section</span></Typography>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', }}>
          <a style={{ display: 'flex', justifyContent: 'center', }} href={'cashkaro://my-earnings'}>
            <img src={EarningButton} alt='EarningButton' style={{ width: '60%' }} />
          </a>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10%' }}>
          <img src={KeepShop} alt='KeepShop' style={{ width: '60%' }} />
        </div>




        <div style={{ marginTop: '1rem', paddingLeft: '1.7rem', paddingRight: '1.7rem', paddingBottom:'1rem', display: 'flex', justifyContent: 'center', }}>
          <a href='cashkaro://stores/clove-oral-care-coupons'>
            <img src={Clove} alt='clove' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ marginTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
          <a href='cashkaro://stores/booking'>
            <img src={Booking} alt='booking' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ marginTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
          <a href='cashkaro://top-selling-products/flash-deals'>
            <img src={Flash} alt='flash' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ marginTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
          <a href='cashkaro://top-selling-products/best-finance-deals'>
            <img src={Card} alt='card' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '4rem' }}>
          <img src={Faq} alt='faq' style={{ width: '30%' }} />
        </div>
        <Box sx={{ paddingX: '18px', marginTop: '3rem' }}>
          {faqs.map((faq, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                background:
                  "transparent",
                borderRadius: "14px",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  background: "transparent",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  fontFamily: 'Metropolis',
                  boxShadow: 'none'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#fce100', }}>
                  {faq?.question}
                </AccordionSummary>
                <AccordionDetails>{faq?.answer}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
        <Box sx={{ paddingX: '18px' }} pb={16}>
          <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
          {Terms.map((Terms, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                borderRadius: "14px",
                background:
                  "transparent",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  color: "#fff",
                  fontSize: "14px",
                  background:
                    "transparent",
                  boxShadow: 'none',
                  fontWeight: 600,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#fce100', }}>
                  {Terms?.question}
                </AccordionSummary>
                <AccordionDetails>{ReactHtmlParser(Terms?.answer)}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
